import React from "react";

const PreferencesContext = React.createContext({});

export const PreferencesProvider = PreferencesContext.Provider;
export const PreferencesConsumer = PreferencesContext.Consumer;
export default PreferencesContext;
